'use client';

import React from 'react';
import { Box, Typography } from '@mui/material';
import { BottomSheet, Button, TextInput } from '@miso/design-system';

export interface AddRoomNameSheetProps {
  open: boolean;
  value: string;
  /** 진행 중 표시(disabled + 라벨 변경) */
  isSubmitting?: boolean;
  /** 이름 입력 placeholder. 미지정 시 '방 이름'. */
  placeholder?: string;
  /** 시트 제목. 미지정 시 '방 이름을 알려주세요'. */
  title?: string;
  /** "추가하기" CTA 라벨. */
  ctaLabel?: string;
  /** 진행 중에 표시되는 CTA 라벨. */
  ctaSubmittingLabel?: string;
  /** 입력 최대 길이. 미지정 시 20. */
  maxLength?: number;
  onChange: (value: string) => void;
  onConfirm: () => void;
  onClose: () => void;
  container?: HTMLElement | null;
}

/**
 * 방 추가 — `OTHER_SPACE` (기타) 선택 시 커스텀 이름을 입력하는 BottomSheet.
 *
 * `AddRoomTypeSheet` 와 한 쌍으로 동작한다 — 호스트가 type 선택 결과를 보고
 * `OTHER_SPACE` 면 이 시트를 띄우는 식.
 */
export function AddRoomNameSheet({
  open,
  value,
  isSubmitting = false,
  placeholder = '방 이름',
  title = '방 이름을 알려주세요',
  ctaLabel = '추가하기',
  ctaSubmittingLabel = '추가 중...',
  maxLength = 20,
  onChange,
  onConfirm,
  onClose,
  container,
}: AddRoomNameSheetProps) {
  return (
    <BottomSheet
      open={open}
      onClose={() => {
        if (!isSubmitting) onClose();
      }}
      container={container}
      aria-label="방 이름 입력"
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
        <Typography
          sx={{
            fontSize: 20,
            fontWeight: 700,
            color: '#111827',
            letterSpacing: '-0.025em',
          }}
        >
          {title}
        </Typography>
        <TextInput
          variant="underline"
          size="m"
          value={value}
          onChange={onChange}
          onKeyDown={(e: React.KeyboardEvent) => {
            if (e.key === 'Enter' && value.trim() && !isSubmitting) onConfirm();
          }}
          placeholder={placeholder}
          maxLength={maxLength}
          autoFocus
          aria-label="방 이름"
        />
        <Button
          variant="primary"
          size="l"
          width="fixed"
          onPress={onConfirm}
          disabled={!value.trim() || isSubmitting}
        >
          {isSubmitting ? ctaSubmittingLabel : ctaLabel}
        </Button>
      </Box>
    </BottomSheet>
  );
}

export default AddRoomNameSheet;
